<template>
    <div :class="toggle" :style="{'min-height':height}">
        <slot name="date"></slot>
        <div>
            <img :src="infoObj.userDocVo ? infoObj.userDocVo.docAvatar || definedImg : definedImg" class="radius50">
        </div>
        <div class="width80d split" ref="textContent">
            <template v-if="infoObj.userDocVo">
                <p class="fs12 color8B93">{{infoObj.userDocVo.docName || '-'}}</p>
            </template>
            <template v-if="infoObj.consultMessage.replyContentType == 'TEXT' ">
                <p class="fs14 content">{{infoObj.consultMessage.replyContent}}</p>
            </template>
            <template v-else-if="infoObj.consultMessage.replyContentType == 'PIC' ">
                <p class="fs14 content flex jcc"><img height="90px" :src="infoObj.consultMessage.replyContent"
                                                      @click="scan(0,infoObj.consultMessage.replyContent)"></p>
            </template>
            <template v-else>
                <p class="fs14 content flex jcc">
                    <a :href="atta.attaFileUrl" :download="atta.attaFileName"
                       class="fs10 color_666" style="text-align: center;">
                        <img :src="fileIcon">
                        <span style="display: block;">{{atta.attaFileName}}</span>
                    </a>
                </p>
            </template>
        </div>
        <PicScan ref="scan"></PicScan>
    </div>
</template>

<script>
  import PicScan from "../../components/common/pic-scan";

  export default {
    name: "consul-message-item",
    components: {PicScan},
    props: ["infoObj"],
    data() {
      return {
        height: 0,
        definedImg: require("../../assets/pat-default.png"),
        fileIcon: require("../../assets/file.png")
      }
    },
    computed: {
      atta() {
        return this.infoObj.attaList && this.infoObj.attaList[0] || {}
      },
      toggle() {
        if (this.infoObj.userDocVo) {
          if (this.infoObj.userDocVo.id == this.docInfo.id) {
            return 'snedItem'
          } else {
            return 'receiveItem'
          }
        } else {
          return 'receiveItem'
        }

      }
    },
    mounted() {
      this.getHeight();
    },
    methods: {
      getHeight() {
        if (this.infoObj.consultMessage.replyContentType == 'FILE') {
          this.height = this.$refs.textContent.offsetHeight + 60 + 'px';
        } else {
          this.height = this.$refs.textContent.offsetHeight + 20 + 'px';
        }
      },
      scan(index = 0, attr) {
        let list = [];
        list.push(attr);
        this.$refs.scan.show(index, list);
      },
    }
  }
</script>

<style lang="scss" scoped>
    .receiveItem {
        width: 98%;
        margin: 5px 10px;
        box-sizing: content-box;

        .content {
            background: #F3F3F3;
        }

        div {
            float: left;
        }

        p {
            text-align: left;

            &:nth-child(1) {
                padding-bottom: 5px;
            }
        }

        .split {
            margin-left: 10px;
        }
    }

    .snedItem {
        width: 98%;
        margin: 5px 10px;
        box-sizing: content-box;
        overflow: hidden;

        .content {
            background: #E6F1FC;
        }

        div {
            float: right;
        }

        p {
            text-align: left;

            &:nth-child(1) {
                padding-bottom: 5px;
                text-align: right;
            }
        }

        .split {
            margin-right: 10px;
        }
    }

    .radius50 {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }

    .color8B93 {
        color: #8B93BA
    }

    .content {
        padding: 10px;
        color: #333333;
        border-radius: 10px;
        word-break: break-all;
    }

    .width80d {
        max-width: 80%;
        min-height: 100%;
    }

    .date {
        display: flex;
        justify-content: center;
        font-size: 10px;
        color: #9A9A9A;
    }
</style>
